import { Badge } from '@/components/ui/badge'
import type { VersionStatus } from '@/lib/api/frameworkConfig'

interface StatusBadgeProps {
  status: VersionStatus
  labels: { active: string; draft: string; retired: string }
}

const variants: Record<VersionStatus, 'default' | 'secondary' | 'outline'> = {
  active: 'default',
  draft: 'secondary',
  retired: 'outline',
}

export function StatusBadge({ status, labels }: StatusBadgeProps) {
  return <Badge variant={variants[status]}>{labels[status]}</Badge>
}
